import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import LineHr from "../Line/LineHr";
export default function CircularProgressbarElement({ name, percentage }) {
  return (
    <div className=" m-3 flex flex-col items-center justify-center w-[220px] h-[220px]">
      <h3 className="font-poppins text-2xl text-center w-full text-white">
        {name}
      </h3>
      <br />
      <LineHr />
      <br />

      <CircularProgressbar
        className="font-lato text-3xl flex w-[100px] h-[100px] "
        value={percentage}
        text={`${percentage}%`}
        styles={buildStyles({
          rotation: 0.25,

          strokeLinecap: "butt",

          pathTransitionDuration: 0.5,

          pathColor: "#DC4492",
          textColor: "#DC4492",
          trailColor: "#d6d6d6",
          fill: "#DC4492",
        })}
      ></CircularProgressbar>
    </div>
  );
}
